export default[ //Students
      {
        path: "/ChO71OpG7tVVBKTuI2O0",
        children: [
          {
            path: "YNoXHyC6Ct",
            name: "baice25.students",
            meta: {
              title: "BAICE 2025 students",
              authRequired: true,
              acc:['y30400']
            },
            component: () => import("@/views/baice/twf/student/index.vue"),
          },
          {
            path: "YNoXHyC6CtrUTGUYTFUYTDGFYD",
            name: "baice25.student.create",
            meta: {
              title: "Create BAICE 2025 student",
              authRequired: true,
              acc :['y90694']
            },
            component: () => import("@/views/baice/twf/student/create.vue"),
          },
          {
            path: "BtKNdN9Vg8BTG8EYQ67FVQ/:str?",
            name: "baice25.student",
            meta: {
              title: "View BAICE 2025 student",
              acc: ['y76662']
            },
            component: () => import("@/views/baice/twf/student/view.vue"),
          },
          {
            path: "OnqQfkp/:str?",
            name: "baice25.studentedit",
            meta: {
              title: "Edit BAICE 2025 student",
              acc: ['y89574']
            },
            component: () => import("@/views/baice/twf/student/edit.vue"),
          },
          // {
          //   path: "generate",
          //   name: "generateExamNumber",
          //   meta: {
          //     title: "GENERATE EXAM NUMBER",
          //   },
          //   component: () =>
          //     import("../views/bece/student_management/generateExamNumber.vue"),
          // },
          // {
          //   path: "export",
          //   name: "exportStudents",
          //   meta: {
          //     title: "EXPORT STUDENTS",
          //   },
          //   component: () =>
          //     import("../views/bece/student_management/exportStudents.vue"),
          // },
        ],
      },]